import LegalPage from "@/components/site/LegalPage";

export default function PrivacyPolicy() {
  return (
    <LegalPage
      kicker="Privacy Policy"
      title="Privacy"
      updated="December 2025"
      sections={[
        {
          heading: "Who We Are",
          body: [
            "This Privacy Policy explains how B&C System Wireline Operator (\"B&C System\", \"we\", \"us\") collects and uses personal information when you use bandcsystem.com or place an order with us.",
            "Contact: 114 Adger Rd, Pendleton, SC 29670, United States · order@bandcsystem.com",
          ],
        },
        {
          heading: "Information We Collect",
          body: [
            "Order & quote information: name, company, email, phone, shipping address, billing address, PO number, order line items, and any notes you submit.",
            "Contact / inquiry information: name, company, email, phone, service requested, and message content submitted through our contact forms.",
            "Technical data: standard server logs including IP address, browser type, referring URL, and timestamps for security and abuse prevention. This site is served over HTTPS with an active SSL certificate.",
          ],
        },
        {
          heading: "How We Use Your Information",
          body: [
            "To process, invoice, and fulfill your orders and to arrange shipping, freight, and installation as applicable.",
            "To respond to quote requests, service inquiries, and support questions.",
            "To keep records required for tax, accounting, warranty, and safety-critical documentation.",
            "To improve the operation and security of our website.",
          ],
        },
        {
          heading: "Sharing",
          body: [
            "We share information only with the third parties strictly needed to fulfill your order or comply with the law — for example, carriers and logistics providers, payment/invoicing processors, and tax authorities.",
            "We do not sell your personal information.",
          ],
        },
        {
          heading: "Data Retention",
          body: [
            "We keep order and invoicing records for as long as required by U.S. tax and accounting law, and for warranty support. Marketing contact records are kept until you ask us to remove them.",
          ],
        },
        {
          heading: "Your Rights",
          body: [
            "You may request access to, correction of, or deletion of your personal data by emailing order@bandcsystem.com. We will respond within a reasonable time and in accordance with applicable law.",
          ],
        },
        {
          heading: "Cookies",
          body: [
            "We use only strictly necessary cookies and local storage (for example, to keep your shopping cart between page loads). We do not use advertising or third-party tracking cookies for marketing purposes.",
          ],
        },
        {
          heading: "Changes",
          body: [
            "We may update this policy from time to time. The \"Last updated\" date at the top of this page reflects the most recent revision.",
          ],
        },
      ]}
    />
  );
}
